import React, { useEffect, useState } from 'react'
import { getRequestsInGroup } from '../../services/cm.service';
import { createGroupDeclaration } from '../../services/em.service';
import { useOktaAuth } from '@okta/okta-react';
import { EMPTY_BODY } from '../../utils/surveyLiterals';
import UploadDownloadEMRT from '../em/UploadDownloadEMRT';
import { SupplierGroup } from '../../components/conflict-mineral/SupplierInGroupList';
import { useUserInfo } from '../../providers/userProvider'
import { useTranslation } from "react-i18next";
import { ErrorCard } from '../../components/ErrorCard';

import { Row, Col, Card,  Button, Form } from '@deere/ux.uxframe-react'

export default function EMSurveyPage({  survey, campaignAssigned  }) {

    const [suppliersInGroup, setSuppliersInGroup] = useState();
    const { authState } = useOktaAuth();
    const [selectedSuppliers, setSelectedSuppliers] = useState([]);
    const userInfo = useUserInfo();
    const { t } = useTranslation();
    const [errors, setErrors] = useState([])
    


    const next = async() => {
        selectedSuppliers.push(campaignAssigned.assignments[0].supplierNumber); // ADD the current supplier
        await createGroupDeclaration(campaignAssigned.assignments[0].campaignId,userInfo.userID,selectedSuppliers,authState.accessToken.accessToken)
            .then((res) => {
                window.location.reload(false);
            }).catch(error => {
                setErrors(['Error processing the request'])
                console.log(error);
            });
    }

    const onCheck = (event) => {
        let aux = [...selectedSuppliers];
        if(event.target.checked){
            aux.push(event.target.defaultValue);
            setSelectedSuppliers([...aux]);
        }else{
            setSelectedSuppliers(aux.filter(it=>it !== event.target.defaultValue));
        }
    }

    const onCheckAll = (event) => {
        let aux = [];
        if(event.target.checked){
            for(let it of suppliersInGroup){
                if(!it.groupNumber){
                    aux.push(it.supplierNumber);
                }
            }
        }
        setSelectedSuppliers([...aux]);
        
    }

    useEffect(() => {
        if (!suppliersInGroup && campaignAssigned && campaignAssigned.assignments && campaignAssigned.assignments.length > 0) {
            getRequestsInGroup(campaignAssigned.assignments[0].supplierNumber,campaignAssigned.id, authState.accessToken.accessToken)
                .then((resRequestsInGroup) => {
                    if(resRequestsInGroup && resRequestsInGroup.length>0){
                        setSuppliersInGroup(resRequestsInGroup);
                    }else{
                        setSuppliersInGroup([campaignAssigned.assignments[0]]);
                    }
                }).catch(error => {
                    console.log(error);
                    setErrors(['Error processing the request'])
                })
        }
    }, [suppliersInGroup, campaignAssigned, authState.accessToken.accessToken]);

    if (!suppliersInGroup) {
        return (EMPTY_BODY);
    }else{
        if(suppliersInGroup.length <= 0 || campaignAssigned.assignments[0].groupNumber) {//Redirect to the upload/download because is only one or it has group assigned or it has group assigned
            return (<UploadDownloadEMRT survey={survey} campaignAssigned={campaignAssigned}/>)
        }else{ //show the supplier list in the group exluding the current supplier
            return (
                <>
                    <Row>
                        <Col md="24" className="card-body p-3 text-left">
                            <h1>{t('cm_lbl_declaration')}</h1>
                        </Col>
                    </Row>
                    {
                        errors.length > 0 ?  <ErrorCard errors={errors}/> : null
                     }
                  
                    <Card>
                        <Card.Body>
                            <Form.Row>
                                <Col md="24" className="card-body p-3 text-center">
                                    <SupplierGroup list={suppliersInGroup} onCheck={onCheck} onCheckAll={onCheckAll} selectedSuppliers={selectedSuppliers} campaign={campaignAssigned}/>
                                </Col>
                            </Form.Row>
                                <Form.Group as={Col} className="align-right">
                            <br />
                        </Form.Group>
                    </Card.Body>
                </Card>
                <br/>
                <Form.Row>
                    <Col>
                        <Button variant="primary" className="float-right" onClick={next}>
                        {t('btn_next')}
                        </Button>
                    </Col>
                </Form.Row>
            </>)
        }
    }
}